module.exports = __webpack_public_path__ + "media/PortafolioReel-low.63ccc569.mp4";